// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__VZhUM","savePackageButton":"ClientWallet_savePackageButton__3n6Mc"};